import React from 'react';
import { Col, Button } from 'reactstrap';
import { injectIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlusCircle } from '@fortawesome/free-solid-svg-icons';

function AddProductItemComponent(props) {
  const {
    index,
    setAddRow,
  } = props;


  return (
    <Col xs={ 6 } sm={ 6 } className="justify-content-end">
      <Button
        className={ "btn-icon-only rounded-circle index-" + index }
        color="info"
        type="button"
        onClick={ setAddRow }
      >
        <FontAwesomeIcon icon={ faPlusCircle }/>
      </Button>
    </Col>);
}

const AddProductItem = injectIntl(AddProductItemComponent)

export { AddProductItem, AddProductItemComponent }
